import React from 'react';
import { HamburgerMenu } from '../components/HamburgerMenu';
import { Hero } from '../components/Hero';
import { NewsletterSignup } from '../components/NewsletterSignup';
import { motion } from 'framer-motion';
import { Coffee, Users, MapPin, Sunrise, ArrowRight } from 'lucide-react';
export function LandingPage() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-[#D97E3A] selection:text-white" data-id="element-158">
      <HamburgerMenu data-id="element-159" />

      <main data-id="element-160">
        <Hero data-id="element-161" />

        {/* Welcome Section */}
        <section className="py-24 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto" data-id="element-162">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-163">
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-164">
              <h2 className="font-bebas text-6xl md:text-8xl mb-8 leading-[0.9]" data-id="element-165">
                WELCOME TO <br data-id="element-166" />
                <span className="text-[#D97E3A]" data-id="element-167">GROUNDED</span>
              </h2>
              <p className="font-inter text-lg text-white/70 leading-relaxed mb-8" data-id="element-168">
                We're more than just a coffee shop, we're a gathering place for
                Livermore locals - A spot to unwind, connect, and enjoy each
                other's company. Our mission is simple: serve great coffee and
                help build a stronger community... one cup at a time.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-12" data-id="element-169">
                <div className="flex flex-col gap-3" data-id="element-170">
                  <Coffee className="text-[#D97E3A]" size={32} data-id="element-171" />
                  <h3 className="font-bebas text-2xl" data-id="element-172">Craft Coffee</h3>
                  <p className="text-sm text-white/50 font-inter" data-id="element-173">
                    Locally roasted beans brewed to perfection.
                  </p>
                </div>
                <div className="flex flex-col gap-3" data-id="element-174">
                  <Users className="text-[#D97E3A]" size={32} data-id="element-175" />
                  <h3 className="font-bebas text-2xl" data-id="element-176">Community</h3>
                  <p className="text-sm text-white/50 font-inter" data-id="element-177">
                    A space for everyone to feel at home.
                  </p>
                </div>
                <div className="flex flex-col gap-3" data-id="element-178">
                  <MapPin className="text-[#D97E3A]" size={32} data-id="element-179" />
                  <h3 className="font-bebas text-2xl" data-id="element-180">Local</h3>
                  <p className="text-sm text-white/50 font-inter" data-id="element-181">
                    Proudly serving Livermore since 2023.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="relative aspect-square lg:aspect-[4/5]" data-id="element-182">
              <div className="absolute inset-0 border-2 border-[#D97E3A] translate-x-4 translate-y-4 z-0" data-id="element-183"></div>
              <img src="https://images.unsplash.com/photo-1509042239860-f550ce710b93?q=80&w=2574&auto=format&fit=crop" alt="Pouring coffee" className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700 z-10" data-id="element-184" />
            </motion.div>
          </div>
        </section>

        {/* Grounded Mornings Section */}
        <section className="py-24 px-6 md:px-12 lg:px-24 bg-[#111] border-y border-white/5" data-id="element-185">
          <div className="max-w-7xl mx-auto" data-id="element-186">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-187">
              <div className="relative aspect-[4/3] overflow-hidden" data-id="element-188">
                <img src="https://images.unsplash.com/photo-1533777857889-4be7c70b33f7?q=80&w=2670&auto=format&fit=crop" alt="Breakfast catering spread" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-189" />
                <div className="absolute inset-0 bg-gradient-to-r from-[#111] via-transparent to-transparent lg:opacity-100 opacity-60" data-id="element-190"></div>
              </div>

              <div data-id="element-191">
                <div className="flex items-center gap-3 mb-6" data-id="element-192">
                  <Sunrise className="text-[#D97E3A]" size={40} strokeWidth={1.5} data-id="element-193" />
                  <h2 className="font-bebas text-5xl md:text-7xl leading-[0.9]" data-id="element-194">
                    GROUNDED <span className="text-[#D97E3A]" data-id="element-195">MORNINGS</span>
                  </h2>
                </div>

                <p className="font-inter text-lg text-white/70 leading-relaxed mb-8" data-id="element-196">
                  Bring the Grounded experience to your venue. Our catering
                  service delivers the same elevated hospitality that makes our
                  shop special - perfect for corporate meetings, weddings, and
                  community gatherings.
                </p>

                <motion.a href="https://project-let-statement-602.magicpatterns.app/" target="_blank" rel="noopener noreferrer" whileHover={{
                scale: 1.05,
                x: 5
              }} whileTap={{
                scale: 0.95
              }} className="inline-flex items-center gap-3 bg-white text-[#0a0a0a] px-8 py-4 font-bebas text-xl tracking-wide hover:bg-white/90 transition-colors group" data-id="element-197">
                  EXPLORE CATERING
                  <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} data-id="element-198" />
                </motion.a>
              </div>
            </motion.div>
          </div>
        </section>

        <NewsletterSignup data-id="element-199" />

        {/* Footer Teaser */}
        <footer className="border-t border-white/10 py-12 text-center" data-id="element-200">
          <p className="font-bebas text-2xl text-white/50" data-id="element-201">
            © {new Date().getFullYear()} GROUNDED LIVERMORE
          </p>
        </footer>
      </main>
    </div>;
}